<!--
tablet 适配:
1. illus 左移 200
2. list 左内边距增加 200
-->
<template>
  <div :class="$style.list">
    <ul>
      <li v-for="(el, index) in data" :key="index">
        <span>{{ el.date }}</span>
        <span>{{ el.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return []
      },
    },
  },
}
</script>

<style lang="less" module>
.list {
  margin-top: 1rem;
  font-size: 16px;
  background: url('./images/honor-illus.png') no-repeat 3.47rem 0;
  background-size: 4.33rem 3.73rem;

  ul {
    min-height: 4rem;
    padding-left: 8.8rem;
    padding-right: 1.5rem;
  }

  li {
    display: flex;
    margin-bottom: 1em;
    line-height: 1.5;
  }

  span {
    display: inline-block;

    &:first-child {
      flex: 0 0 6em;
      white-space: nowrap;
    }
  }

  @media screen and (max-width: @laptop-width) {
    font-size: 14px;
  }

  @media screen and (max-width: @tablet-width) {
    background-position: 1.47rem 0;

    ul {
      padding-left: 6.8rem;
    }
  }

  @media screen and (max-width: @mini-width) {
    background: none;

    ul {
      padding: 0 1.5rem;
    }
  }
}
</style>
